import { dcpcApi } from './dcpcApi';

export const CHANNEL_TYPE_PARAM_VALUE_TAG = 'ChannelTypeParamValue';
export const CHANNEL_TYPE_PARAM_VALUE_MUTATION_TAG = 'ChannelTypeParamValueMutation';

dcpcApi.enhanceEndpoints({ addTagTypes: [CHANNEL_TYPE_PARAM_VALUE_TAG, CHANNEL_TYPE_PARAM_VALUE_MUTATION_TAG] });

const channelTypeParamValuesApi = dcpcApi.injectEndpoints({
  endpoints: (builder) => ({
    getChannelTypeParamValueById: builder.query({
      query: (id) => `channel-type-param-values/${id}`,
      providesTags: [CHANNEL_TYPE_PARAM_VALUE_TAG],
    }),

    updateChannelTypeParamValue: builder.mutation({
      query: ({ id, body }) => ({
        url: `channel-type-param-values${id ? `/${id}` : ''}`,
        method: id ? 'PUT' : 'POST',
        body,
      }),
      invalidatesTags: [CHANNEL_TYPE_PARAM_VALUE_TAG],
    }),

    deleteChannelTypeParamValueById: builder.mutation({
      query: (id) => ({
        url: `channel-type-param-values/${id}`,
        method: 'DELETE',
      }),
      invalidatesTags: [CHANNEL_TYPE_PARAM_VALUE_TAG, CHANNEL_TYPE_PARAM_VALUE_MUTATION_TAG],
    }),
  }),
});

export const {
  useGetChannelTypeParamValueByIdQuery,
  useUpdateChannelTypeParamValueMutation,
  useDeleteChannelTypeParamValueByIdMutation,
} = channelTypeParamValuesApi;
